import React from 'react';
import Button from '../form/Button';
import type { CategoryWithSubCategories } from '@dr-pam/common-components/Services/Server/CategoryService';

type QuizStepAgeProps = {
	onSelected: (category: CategoryWithSubCategories) => void;
	data?: CategoryWithSubCategories[];
};

type QuizAgeButtonProps = {
	onSelected: (category: CategoryWithSubCategories) => void;
	category: CategoryWithSubCategories;
};

const CATEGORIES_WITH_ICONS = ['baby-sleep-1-12-months', 'toddler-sleep-12-36-months', 'newborn-sleep-0-4-weeks'];

const QuizAgeButton = (props: QuizAgeButtonProps) => {
	const { category, onSelected } = props;
	const match = category.name.match(/^([^()]+)(\(.*)$/);
	const hasIcon = CATEGORIES_WITH_ICONS.includes(category.slug);

	return (
		<Button className="solid outline reverse quiz icon" onClick={() => onSelected(category)}>
			{hasIcon && (
				// eslint-disable-next-line @next/next/no-img-element
				<img src={`/images/quiz/${category.slug}.svg`} width={26} height={26} alt={category.slug} />
			)}
			{match ? (
				<div className="quiz-button__title">
					<span>{match[1]}</span>
					<span>{match[2]}</span>
				</div>
			) : (
				<div className="quiz-button__title">
					<span>{category.name}</span>
				</div>
			)}
		</Button>
	);
};

export default function QuizStepAge(props: QuizStepAgeProps) {
	const { data, onSelected } = props;

	return (
		<div className="quiz-age-container">
			{data?.map((category) => (
				<QuizAgeButton key={category.id} category={category} onSelected={onSelected} />
			))}
		</div>
	);
}
